export default __webpack_public_path__ + "static/Tecnici-5b4d2fcb61f974542ca45f5dc3a02027.jpg";